module.exports = __webpack_public_path__ + "img/family_pic_desc_1.dce0c76b.png";